import type { PendingAction } from "./types";

function storageKey(token: string): string {
  return `attendance.pending.${token}`;
}

export function loadPending(token: string): PendingAction[] {
  try {
    const raw = localStorage.getItem(storageKey(token));
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(isPendingAction);
  } catch {
    return [];
  }
}

export function storePending(token: string, actions: PendingAction[]): void {
  try {
    if (actions.length === 0) {
      localStorage.removeItem(storageKey(token));
      return;
    }
    localStorage.setItem(storageKey(token), JSON.stringify(actions));
  } catch {
    // Private browsing or storage policy can disable localStorage. The UI still
    // reports the failed sync and lets the marker retry manually.
  }
}

export function upsertPending(actions: PendingAction[], next: PendingAction): PendingAction[] {
  return [...actions.filter((action) => action.memberId !== next.memberId), next];
}

function isPendingAction(value: unknown): value is PendingAction {
  if (!value || typeof value !== "object") return false;
  const action = value as Record<string, unknown>;
  return (
    typeof action.memberId === "string" &&
    typeof action.memberName === "string" &&
    typeof action.attending === "boolean"
  );
}

